// Tipos
export type * from './types';

// Cliente HTTP base + helpers de tokens
export {
  apiClient,
  API_BASE_URL,
  getAccessToken,
  getRefreshToken,
  setTokens,
  setAccessToken,
  clearTokens,
} from './client';

// Auth
export { login, refreshToken } from './auth';

// Usuarios, grupos, permisos, auditoría
export {
  listarUsuarios,
  verUsuario,
  crearUsuario,
  registrarUsuario,
  actualizarUsuario,
  activarUsuario,
  eliminarUsuario,
  perfilPropio,
  actualizarPerfil,
  cambiarContrasena,
  resetearContrasena,
  vincularVendedorErp,
  listarGrupos,
  verGrupo,
  crearGrupo,
  actualizarGrupo,
  eliminarGrupo,
  listarPermisos,
  asignarPermisos,
  listarModulos,
  listarAuditLogs,
} from './usuarios';

// Parámetros y MinIO
export {
  listarParametrosPublicos,
  listarParametros,
  verParametro,
  crearParametro,
  actualizarParametro,
  eliminarParametro,
  generarEnlaceSubidaMinio,
} from './parametros';

// Tenants
export {
  listarTenants,
  verTenant,
  crearTenant,
  eliminarTenant,
} from './tenants';

// Health checks
export { healthCheck, healthHeaders } from './core';
// Bodega / Insumos
export {
  getProveedores,
  createProveedor,
  updateProveedor,
  deleteProveedor,
  getInsumos,
  getInsumosPaginados,
  createInsumo,
  updateInsumo,
  deleteInsumo,
  cargaMasivaInsumos,
  getAsignacionesInsumosVehiculos,
  getAsignacionesInsumosVehiculosPaginadas,
  getMantenimientosPaginados,
  createAsignacionInsumosVehiculo,
  updateAsignacionInsumosVehiculo,
  deleteAsignacionInsumosVehiculo,
  exportarInsumos,
  getExportarInsumosStatus,
  descargarExportacionInsumos,
  exportarAsignaciones,
  getExportarAsignacionesStatus,
  descargarExportacionAsignaciones,
  getMantenimientos,
  createMantenimiento,
  updateMantenimiento,
  deleteMantenimiento,
} from './bodega';

export {
  getCajas,
  getCajaActual,
  abrirCaja,
  cerrarCaja,
  agregarViajeCaja,
} from './caja';

export {
  getReporteKilometros,
} from './reportes';

export type {
  KilometroItem,
  KilometrosReporte,
  KilometrosParams,
} from './reportes';

